import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule, IsActiveMatchOptions } from '@angular/router';
import { CommonModule } from '@angular/common';

export interface TabI {
  label: string;
  route: string;
  disabled?: boolean;
  icon?: string;
  prefix?: string;
}

@Component({
  selector: 'app-tab-navigators',
  templateUrl: './tab-navigator.component.html',
  styleUrls: ['./tab-navigator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabNavigatorsComponent {
   @Input() tabs: TabI[] = [];
  @Input() floatPosition: 'left' | 'right' | 'center' = 'left';
  @Input() tabSize: 'compact' | 'full' = 'compact';
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  /** When true, active only if URL matches exactly. Default false so parent tab stays active for child routes. */
  @Input() exactMatch = false;

  /** Optional base for relative links (e.g. '.'), used by nested tabs. */
  @Input() baseRoute: string | string[] | null = null;

  /** Keep ticketId etc. */
  @Input() queryParamsHandling: 'merge' | 'preserve' | '' = 'merge';

  @Output() selectedTabDetails = new EventEmitter<TabI>();

  constructor() {
    if (this.tabSize === 'full') this.floatPosition = 'center';
  }

  onTabClick(e: MouseEvent, tab: TabI) {
  if (tab.disabled) { e.preventDefault(); }
}
}
